export default "__VITE_ASSET__C08vC_T4__"